export default __webpack_public_path__ + "static/media/map-pin-location-past-days.e074dcd2.svg";